
  import { Handshake, BitbucketClients, BBCommitStatusEvent, AnyObject, Follower, Message, UserCollection, UpdateVisibility, CreateDashboard, Dashboard, UpdateDashboard, Subscription, SubscriptionSession, VerifySession, User, Job, JobCollection, JobHistoryCollection } from './model'
  
  export type Caller = {
  call(
      method: string,
      resource: string,
      path: string,
      body: string | undefined,
      pathParameters: Record<string, string>,
      queryParameters: Record<string, string>,
      multiQueryParameters: Record<string, string[]>,
      headers: Record<string, string>,
      config?: Record<string, string>,
    ): Promise<{ statusCode: number; body: string; headers: Record<string, string> }>;
  }
  
  export class GitboardApiSdk {
    constructor(
      private readonly caller: Caller
    ){}
  
        async handshake(headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: Handshake }) & {headers: Record<string, string>}>{
      const resource = '/handshake';
      const path = `/handshake`;
      const result = await this.caller.call('GET', resource, path, undefined, {}, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async bitbucketClients(headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: BitbucketClients }) & {headers: Record<string, string>}>{
      const resource = '/bitbucket';
      const path = `/bitbucket`;
      const result = await this.caller.call('GET', resource, path, undefined, {}, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async bitbucketWebhook(body: BBCommitStatusEvent, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/bitbucket/webhook';
      const path = `/bitbucket/webhook`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), {}, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async bitbucketRedirect(params: {handshake: string}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/bitbucket/handshake/{handshake}';
      const path = `/bitbucket/handshake/${params.handshake}`;
      const result = await this.caller.call('GET', resource, path, undefined, params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async bitbucketLinkUser(params: {handshake: string}, body: AnyObject, queryParameters: {clientKey?: string}, multiQueryParameters: {clientKey?: string[]}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown } | { statusCode: 401; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/bitbucket/handshake/{handshake}';
      const path = `/bitbucket/handshake/${params.handshake}`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), params, queryParameters, multiQueryParameters, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 401) {
        return { statusCode: 401, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async bitbucketConnect(headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/bitbucket/connect';
      const path = `/bitbucket/connect`;
      const result = await this.caller.call('GET', resource, path, undefined, {}, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async bitbucketInstall(body: AnyObject, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/bitbucket/install';
      const path = `/bitbucket/install`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), {}, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async bitbucketUninstall(body: AnyObject, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/bitbucket/uninstall';
      const path = `/bitbucket/uninstall`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), {}, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async upsertFollower(body: Follower, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 201; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/follower';
      const path = `/follower`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), {}, {}, {}, headers, config);
      if(result.statusCode === 201) {
        return { statusCode: 201, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async sendMessage(body: Message, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 201; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/message';
      const path = `/message`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), {}, {}, {}, headers, config);
      if(result.statusCode === 201) {
        return { statusCode: 201, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async getUsers(headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: UserCollection }) & {headers: Record<string, string>}>{
      const resource = '/user';
      const path = `/user`;
      const result = await this.caller.call('GET', resource, path, undefined, {}, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async regenerateKey(params: {username: string}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/user/{username}/key';
      const path = `/user/${params.username}/key`;
      const result = await this.caller.call('POST', resource, path, undefined, params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async updateVisibility(params: {username: string}, body: UpdateVisibility, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/user/{username}/visibility';
      const path = `/user/${params.username}/visibility`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async createDashboard(params: {username: string}, body: CreateDashboard, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/user/{username}/dashboard';
      const path = `/user/${params.username}/dashboard`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async getDashboard(params: {username: string; id: string}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: Dashboard } | { statusCode: 403; result: string } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/user/{username}/dashboard/{id}';
      const path = `/user/${params.username}/dashboard/${params.id}`;
      const result = await this.caller.call('GET', resource, path, undefined, params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 403) {
        return { statusCode: 403, headers: result.headers, result: result.body  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async updateDashboard(params: {username: string; id: string}, body: UpdateDashboard, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/user/{username}/dashboard/{id}';
      const path = `/user/${params.username}/dashboard/${params.id}`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async deleteDashboard(params: {username: string; id: string}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/user/{username}/dashboard/{id}';
      const path = `/user/${params.username}/dashboard/${params.id}`;
      const result = await this.caller.call('DELETE', resource, path, undefined, params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async createSubscription(body: Subscription, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: SubscriptionSession } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/subscribe';
      const path = `/subscribe`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), {}, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async verifySubscription(body: VerifySession, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: Subscription } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/verify';
      const path = `/verify`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), {}, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async getUser(params: {username: string}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: User } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/user/{username}';
      const path = `/user/${params.username}`;
      const result = await this.caller.call('GET', resource, path, undefined, params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async deleteUser(params: {username: string}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/user/{username}';
      const path = `/user/${params.username}`;
      const result = await this.caller.call('DELETE', resource, path, undefined, params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async upsertJob(params: {username: string}, body: Job, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown } | { statusCode: 401; result: unknown } | { statusCode: 403; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/job/{username}';
      const path = `/job/${params.username}`;
      const result = await this.caller.call('POST', resource, path, JSON.stringify(body), params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 401) {
        return { statusCode: 401, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 403) {
        return { statusCode: 403, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async getJobs(params: {username: string}, queryParameters: {dashboard?: string}, multiQueryParameters: {dashboard?: string[]}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: JobCollection }) & {headers: Record<string, string>}>{
      const resource = '/job/{username}';
      const path = `/job/${params.username}`;
      const result = await this.caller.call('GET', resource, path, undefined, params, queryParameters, multiQueryParameters, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async getJob(params: {username: string; id: string}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: Job } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/job/{username}/{id}';
      const path = `/job/${params.username}/${params.id}`;
      const result = await this.caller.call('GET', resource, path, undefined, params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async deleteJob(params: {username: string; id: string}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: unknown } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/job/{username}/{id}';
      const path = `/job/${params.username}/${params.id}`;
      const result = await this.caller.call('DELETE', resource, path, undefined, params, {}, {}, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }

    async getJobHistories(params: {username: string; id: string}, queryParameters: {dashboard?: string}, multiQueryParameters: {dashboard?: string[]}, headers: Record<string, string> = {}, config: Record<string, any> = {}): Promise<({ statusCode: 200; result: JobHistoryCollection } | { statusCode: 404; result: unknown }) & {headers: Record<string, string>}>{
      const resource = '/job/{username}/{id}/history';
      const path = `/job/${params.username}/${params.id}/history`;
      const result = await this.caller.call('GET', resource, path, undefined, params, queryParameters, multiQueryParameters, headers, config);
      if(result.statusCode === 200) {
        return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body)  };
      } else if(result.statusCode === 404) {
        return { statusCode: 404, headers: result.headers, result: JSON.parse(result.body)  };
      }
      throw new Error(`Unknown status ${result.statusCode} returned from ${path}`)
    }
  }
  
  export * from './model.js';
